"use client";

import { c as _c } from "react/compiler-runtime";
import { BlockPickerTimeWindow } from "@/app/tools/block-finder/page.client";
import { motion, useAnimate } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
import AllowlistToolAnimationWrapper from "../allowlist-tool/common/animation/AllowlistToolAnimationWrapper";
import BlockPickerTimeWindowSelectList from "./BlockPickerTimeWindowSelectList";
export default function BlockPickerTimeWindowSelect(t0) {
  const $ = _c(33);
  const {
    timeWindow,
    setTimeWindow
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      title: "None",
      value: BlockPickerTimeWindow.NONE
    }, {
      title: "1 minute",
      value: BlockPickerTimeWindow.ONE_MINUTE
    }, {
      title: "5 minutes",
      value: BlockPickerTimeWindow.FIVE_MINUTES
    }, {
      title: "10 minutes",
      value: BlockPickerTimeWindow.TEN_MINUTES
    }, {
      title: "30 minutes",
      value: BlockPickerTimeWindow.HALF_HOUR
    }, {
      title: "1 hour",
      value: BlockPickerTimeWindow.ONE_HOUR
    }, {
      title: "2 hours",
      value: BlockPickerTimeWindow.TWO_HOURS
    }, {
      title: "4 hours",
      value: BlockPickerTimeWindow.FOUR_HOURS
    }, {
      title: "6 hours",
      value: BlockPickerTimeWindow.SIX_HOURS
    }, {
      title: "12 hours",
      value: BlockPickerTimeWindow.TWELVE_HOURS
    }, {
      title: "1 day",
      value: BlockPickerTimeWindow.ONE_DAY
    }, {
      title: "2 days",
      value: BlockPickerTimeWindow.TWO_DAYS
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const options = t1;
  const [isOpen, setIsOpen] = useState(false);
  const [iconScope, animateIcon] = useAnimate();
  let t2;
  if ($[1] !== isOpen) {
    t2 = () => setIsOpen(!isOpen);
    $[1] = isOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const toggleOpen = t2;
  let t3;
  if ($[3] !== animateIcon || $[4] !== iconScope || $[5] !== isOpen) {
    t3 = () => {
      if (isOpen) {
        animateIcon(iconScope.current, {
          rotate: 0
        });
      } else {
        animateIcon(iconScope.current, {
          rotate: -90
        });
      }
    };
    $[3] = animateIcon;
    $[4] = iconScope;
    $[5] = isOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t3);
  const listRef = useRef(null);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useClickAway(listRef, t4);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsOpen(false);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useKeyPressEvent("Escape", t5);
  const [title, setTitle] = useState(options.find(o => o.value === timeWindow)?.title ?? "Select time window");
  let t6;
  if ($[9] !== setTimeWindow) {
    t6 = tw => {
      setTitle(options.find(o_0 => o_0.value === tw)?.title ?? "Select time window");
      setTimeWindow(tw);
      setIsOpen(false);
    };
    $[9] = setTimeWindow;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const onTimeWindowSelect = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <label className="tw-block tw-text-sm tw-font-normal tw-leading-5 tw-text-iron-100">Select window length</label>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== toggleOpen) {
    t8 = e => {
      e.stopPropagation();
      toggleOpen();
    };
    $[12] = toggleOpen;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== title) {
    t9 = <span className="tw-block tw-truncate">{title}</span>;
    $[14] = title;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== iconScope) {
    t11 = <span className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-3.5"><svg ref={iconScope} className="tw-h-5 tw-w-5 tw-text-zinc-400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">{t10}</svg></span>;
    $[17] = iconScope;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isOpen || $[20] !== t11 || $[21] !== t8 || $[22] !== t9) {
    t12 = <button type="button" className="tw-relative tw-flex tw-items-center tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-px-3.5 tw-bg-iron-700/40 tw-text-white tw-font-light tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700/40 placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-bg-transparent focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-700 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out" aria-haspopup="listbox" aria-expanded={isOpen} aria-labelledby="listbox-label" onClick={t8}>{t9}{t11}</button>;
    $[19] = isOpen;
    $[20] = t11;
    $[21] = t8;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== isOpen || $[25] !== onTimeWindowSelect || $[26] !== timeWindow) {
    t13 = isOpen && <motion.div className="tw-origin-top-right tw-absolute tw-right-0 tw-mt-1 tw-w-full tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className="tw-rounded-lg tw-overflow-hidden"><BlockPickerTimeWindowSelectList setTimeWindow={onTimeWindowSelect} timeWindow={timeWindow} options={options} /></div></motion.div>;
    $[24] = isOpen;
    $[25] = onTimeWindowSelect;
    $[26] = timeWindow;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <AllowlistToolAnimationWrapper>{t13}</AllowlistToolAnimationWrapper>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t12 || $[31] !== t14) {
    t15 = <div ref={listRef} className="tw-w-full">{t7}<div className="tw-relative tw-mt-1.5">{t12}{t14}</div></div>;
    $[30] = t12;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
}